export const fetchFeatureCollection = (collection) => dispatch => {
  dispatch({
    type: 'FETCH_FEATURE_COLLECTION',
    payload: collection,
  })
 }